import Api from './api';

const inlandPricesListRequest = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/inland/prices', {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}

const updateInlandPriceRequest = (data) => {
    console.log(data.id)
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().put('/api/inland/price/' + data.id, data, { headers: { Authorization: 'Bearer ' + access_token } })
}

const storeInlandPriceRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/inland/price/', data, { headers: { Authorization: 'Bearer ' + access_token } })
}



export default { inlandPricesListRequest, updateInlandPriceRequest, storeInlandPriceRequest }



// WEBPACK FOOTER //
// ./src/api/apiInlandPrices.js